
import { AfterViewInit, Component, ElementRef, ViewChild, Input, OnInit } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';
import { formatDate } from '@angular/common';

declare var google: any;

@Component({
    selector: 'app-bar-chart-daily',
    template: `<div #chartDiv1  id="initial_chart_div1" style="width: 100%; height: 100%;"></div>`
})
export class BarChartDailyComponent implements OnInit {
    name = 'Angular';
    getPerformanceGraphDaily: any;
    currentyear = (new Date()).getFullYear();
    @ViewChild('chartDiv1') pieChart: ElementRef
    constructor(private dashboardService: DashboardService) { }
    yr: any;
    @Input() set countDaily(countDaily: number) {
        this.yr = countDaily;

        google.charts.load('current', { 'packages': ['bar'] });
        google.charts.setOnLoadCallback(drawChart);
        var data1 = [];
        if(this.yr!=='undefined')
        {
            var v = this.dashboardService.getPerformanceGraphDaily(this.yr)
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getPerformanceGraphDaily response---", data)
                    this.getPerformanceGraphDaily = data.respData;
                    if (data.respData.length > 0) {
                    var Header = [];
                    Header.push('Name');
                    for (var i = 0; i < data.respData.length; i++) {
                        Header.push(data.respData[i].fullNm);
                    }
                    data1.push(Header);
                    var temp = [];temp.push('');
                    for (var i = 0; i < data.respData.length; i++) {
                       
                        // temp.push(data.respData[i].fullNm);
                        temp.push(data.respData[i].count);
                       
                    }
                    data1.push(temp);
                    var data = new google.visualization.arrayToDataTable(data1);

                    const options = {
                         scaleShowLabels : true,
                        height: 200,
                        isStacked: false,
                        vAxis: { format: 'decimal',barShowLabels: false,  },
                        hAxis: { format: '',
                        textStyle : {
							fontSize : 0
						}
                    },
                        
                        series: {
                            0: { color: '#fdd835' },
                            1: { color: '#0091ff' },
                            2: { color: '#e53935' },
                            3: { color: '#43a047' },
                        }
                    };

                    const chart = new google.charts.Bar(document.querySelector('#initial_chart_div1'));

                    chart.draw(data, google.charts.Bar.convertOptions(options));
                }
                else
                {

                    var Header1 = ['Name', 'Density'];
                    data1.push(Header1);
                    var data = new google.visualization.arrayToDataTable(data1);
                    const options = {
                        height: 200,
                        isStacked: false,
                        vAxis: { format: 'decimal' },
                        hAxis: { format: '' },
                        series: {
                            0: { color: '#fdd835' },
                            1: { color: '#0091ff' },
                            2: { color: '#e53935' },
                            3: { color: '#43a047' },
                        }
                    }
                    const chart = new google.charts.Bar(document.querySelector('#initial_chart_div1'));
                    chart.draw(data, google.charts.Bar.convertOptions(options));
                }
                },
                error => {
                    console.log(error)
                })
        }
       


        function drawChart() {



        }

    }

    ngOnInit() {
        var currentMonth = (new Date()).getMonth() + 1;
        var d = currentMonth + '/' + this.currentyear;

        this.drawChart(d);

    }

    drawChart(datef) {
        datef=new Date();
        datef = formatDate(new Date(datef), 'yyyy-MM-dd', 'en-US');
        google.charts.load('current', { 'packages': ['bar'] });
        google.charts.setOnLoadCallback(drawChart);
        var data1 = [];
        var v = this.dashboardService.getPerformanceGraphDaily(datef)
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getPerformanceGraphMonthly response---", data)
                    this.getPerformanceGraphDaily = data.respData;
                    if (data.respData.length > 0) {
                    var Header = [];
                    Header.push('Name');
                    for (var i = 0; i < data.respData.length; i++) {
                        Header.push(data.respData[i].fullNm);
                    }
                    data1.push(Header);
                    var temp = [];temp.push('');
                    for (var i = 0; i < data.respData.length; i++) {
                       
                        // temp.push(data.respData[i].fullNm);
                        temp.push(data.respData[i].count);
                       
                    }
                    data1.push(temp);
                }
                else
                {

                    var Header1 = ['Name', 'Density'];
                    data1.push(Header1);
                    var data = new google.visualization.arrayToDataTable(data1);
                    const options = {
                        height: 200,
                        isStacked: false,
                        vAxis: { format: 'decimal' },
                        hAxis: { format: '' ,
                        textStyle : {
							fontSize : 0
						}},
                        series: {
                            0: { color: '#fdd835' },
                            1: { color: '#0091ff' },
                            2: { color: '#e53935' },
                            3: { color: '#43a047' },
                        }
                    }
                    const chart = new google.charts.Bar(document.querySelector('#initial_chart_div1'));
                    chart.draw(data, google.charts.Bar.convertOptions(options));
                }
                },
                error => {
                    console.log(error)
                })


        function drawChart() {


            var data = new google.visualization.arrayToDataTable(data1);
            // chart.draw(chartdata, options);
            // var data = this.data1;

            const options = {
                height: 200,
                isStacked: false,
                vAxis: { format: 'decimal' },
                hAxis: { format: '',
                textStyle : {
                    fontSize : 0
                } },
                series: {
                    0: { color: '#fdd835' },
                    1: { color: '#0091ff' },
                    2: { color: '#e53935' },
                    3: { color: '#43a047' },
                }
            };

            const chart = new google.charts.Bar(document.querySelector('#initial_chart_div1'));

            chart.draw(data, google.charts.Bar.convertOptions(options));
        }
    }
}
